import { render, staticRenderFns } from "./WinterSportsModal.vue?vue&type=template&id=5bae84ee&scoped=true"
import script from "./WinterSportsModal.vue?vue&type=script&lang=js"
export * from "./WinterSportsModal.vue?vue&type=script&lang=js"
import style0 from "./WinterSportsModal.vue?vue&type=style&index=0&id=5bae84ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bae84ee",
  null
  
)

export default component.exports